import { FC } from 'react';
import cx from 'classnames';

import styles from './SvgIcon.module.sass';

interface SvgIconProps {
  name: string;
  className?: string;
}

const SvgIcon: FC<SvgIconProps> = ({ name, className }) => {
  const classes = cx(styles.icon, className);

  return (
    <svg className={classes}>
      <use
        xmlnsXlink="http://www.w3.org/1999/xlink"
        xlinkHref={`#icon-${name}`}
      />
    </svg>
  );
};

SvgIcon.defaultProps = {
  className: '',
};

export default SvgIcon;
